export * from './colaborador-detail';
export * from './new-colaborador-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/colaboradores/index.ts